import { resizeProperty } from '@/helpers';
import { ActionIcon, Group, Image, Menu, Tooltip } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import {
  IconBoxAlignBottomLeft,
  IconBoxAlignBottomRight,
  IconBoxAlignTopLeft,
  IconBoxAlignTopRight,
} from '@tabler/icons-react';

const POSITION_MAPPINGS = {
  top_left: { position: 'absolute', top: '10px', left: '10px' },
  bottom_left: { position: 'absolute', bottom: '10px', left: '10px' },
  bottom_right: { position: 'absolute', bottom: '10px', right: '10px' },
  top_right: { position: 'absolute', top: '10px', right: '10px' }, // Default
};

export function SlideLogo({ presentation, form, formValues, containerWidth }) {
  return (
    <Group style={POSITION_MAPPINGS[formValues.logo_pos] || POSITION_MAPPINGS.top_right}>
      {/* {hovered && (
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Tooltip label="Logo position">
              <ActionIcon
                variant="subtle"
                aria-label="Settings"
                pos="absolute"
                style={{ top: 5, left: 5 }}
              >
                <IconBoxAlignTopLeft
                  style={{ width: '70%', height: '70%' }}
                  stroke={2}
                  color="#868E96"
                />
              </ActionIcon>
            </Tooltip>
          </Menu.Target>

          <Menu.Dropdown ref={ref}>
            <Menu.Item
              onClick={() => form.setValues({ logo_pos: 'top_left' })}
              leftSection={<IconBoxAlignTopLeft size={14} />}
            >
              Top left
            </Menu.Item>
            <Menu.Item
              onClick={() => form.setValues({ logo_pos: 'top_right' })}
              leftSection={<IconBoxAlignTopRight size={14} />}
            >
              Top right
            </Menu.Item>
            <Menu.Item
              onClick={() => form.setValues({ logo_pos: 'bottom_left' })}
              leftSection={<IconBoxAlignBottomLeft size={14} />}
            >
              Bottom left
            </Menu.Item>
            <Menu.Item
              onClick={() => form.setValues({ logo_pos: 'bottom_right' })}
              leftSection={<IconBoxAlignBottomRight size={14} />}
            >
              Bottom right
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )} */}

      <Image
        src={
          presentation.unlimited_plan ? formValues.logo_url : '/image/slides-generator-branding.png'
        }
        w={resizeProperty(containerWidth, 200)}
        radius="md"
      />
    </Group>
  );
}
